import React, { useEffect, useState } from 'react';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Balances() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    API.get('/balances').then(res => setData(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="app-shell"><div className="loading">Loading balances...</div></div>;

  const myBalance = data?.personalBalances.find(b => b.userId === user.id);
  const myNet = myBalance?.netBalance || 0;
  const iOwe = data?.ledger.filter(l => l.fromUserId === user.id) || [];
  const owedToMe = data?.ledger.filter(l => l.toUserId === user.id) || [];

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="topbar-title">Balances</div>
      </div>
      <div className="page fade-in">

        {/* My balance */}
        <div className="card" style={{ background: 'linear-gradient(135deg, #eff6ff, #f5f3ff)', marginBottom: 24, textAlign: 'center', padding: '28px 20px', border: '1px solid #dbeafe' }}>
          <div style={{ fontSize: 12, color: 'var(--text2)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 12 }}>Your Net Balance</div>
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: 40, fontWeight: 800, marginBottom: 12 }}>
            Rs. {Math.abs(myNet).toLocaleString()}
          </div>
          <div className={`balance-pill ${myNet > 0 ? 'balance-positive' : myNet < 0 ? 'balance-negative' : 'balance-zero'}`} style={{ fontSize: 14 }}>
            {myNet > 0 ? '🟢 You are owed this amount' : myNet < 0 ? '🔴 You owe this amount' : '✅ All settled up'}
          </div>
        </div>

        {/* I owe */}
        {iOwe.length > 0 && (
          <>
            <div className="section-header"><div className="section-title">You Owe</div></div>
            {iOwe.map((entry, i) => (
              <div key={i} className="card" style={{ padding: '14px 18px' }}>
                <div className="row-between">
                  <div className="flex gap-8">
                    <div className="avatar" style={{ background: 'rgba(247,90,90,0.2)', color: 'var(--danger)' }}>{entry.toName[0]}</div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{entry.toName}</div>
                      <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>Pending settlement</div>
                    </div>
                  </div>
                  <span style={{ fontFamily: 'Syne', fontWeight: 700, color: 'var(--danger)', fontSize: 16 }}>
                    Rs. {entry.amount.toLocaleString()}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}

        {/* Owed to me */}
        {owedToMe.length > 0 && (
          <>
            <div className="section-header" style={{ marginTop: 16 }}><div className="section-title">Owed to You</div></div>
            {owedToMe.map((entry, i) => (
              <div key={i} className="card" style={{ padding: '14px 18px' }}>
                <div className="row-between">
                  <div className="flex gap-8">
                    <div className="avatar" style={{ background: 'rgba(90,247,160,0.2)', color: 'var(--success)' }}>{entry.fromName[0]}</div>
                    <div>
                      <div style={{ fontWeight: 600 }}>{entry.fromName}</div>
                      <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>Owes you</div>
                    </div>
                  </div>
                  <span style={{ fontFamily: 'Syne', fontWeight: 700, color: 'var(--success)', fontSize: 16 }}>
                    Rs. {entry.amount.toLocaleString()}
                  </span>
                </div>
              </div>
            ))}
          </>
        )}

        {/* Full group ledger */}
        <div className="section-header" style={{ marginTop: 24 }}><div className="section-title">Full Group Ledger</div></div>

        {data?.ledger.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '32px', color: 'var(--text2)' }}>
            🎉 Everyone is settled up!
          </div>
        ) : (
          data?.ledger.map((entry, i) => (
            <div key={i} className="card" style={{ padding: '14px 18px' }}>
              <div className="row-between">
                <div style={{ fontSize: 14 }}>
                  <span style={{ fontWeight: 700, color: entry.fromUserId === user.id ? 'var(--danger)' : 'var(--text)' }}>{entry.fromName}</span>
                  <span style={{ color: 'var(--text2)', margin: '0 8px' }}>owes</span>
                  <span style={{ fontWeight: 700, color: entry.toUserId === user.id ? 'var(--success)' : 'var(--text)' }}>{entry.toName}</span>
                </div>
                <span style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 15 }}>Rs. {entry.amount.toLocaleString()}</span>
              </div>
            </div>
          ))
        )}

        {/* All personal balances */}
        <div className="section-header" style={{ marginTop: 24 }}><div className="section-title">Everyone's Balance</div></div>
        {data?.personalBalances.sort((a, b) => b.netBalance - a.netBalance).map(b => (
          <div key={b.userId} className="card" style={{ padding: '14px 18px' }}>
            <div className="row-between">
              <div className="flex gap-8">
                <div className="avatar">{b.name[0]}</div>
                <span style={{ fontWeight: 600 }}>{b.name}{b.userId === user.id ? ' (you)' : ''}</span>
              </div>
              <span className={`balance-pill ${b.netBalance > 0 ? 'balance-positive' : b.netBalance < 0 ? 'balance-negative' : 'balance-zero'}`} style={{ fontSize: 13 }}>
                {b.netBalance > 0 ? `+Rs.${b.netBalance.toLocaleString()}` : b.netBalance < 0 ? `-Rs.${Math.abs(b.netBalance).toLocaleString()}` : 'Settled'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
